'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('actionPlanCriteriaModule')

.factory('grcActionPlanCriteriaService', ['$http', '$q', function ($http, $q) {

    var baseUrl = environment.apiUrl + '/Pilot/api/Recom';
    var service = {};

    // Retrieve Action Plan Criterias (Deliverables)
    service.getActionPlanCriteria = function (actionPlanCriteriaId) {
        return $http
                .get(baseUrl + '/ActionPlanCriteria/' + actionPlanCriteriaId)
                .then(function (response) { return response.data; });
    };

    // Get FollowUps by action plan criteria
    service.getFollowUpListByActionPlanCriteria = function (actionPlanId, actionPlanCriteriaId) {
        var reqUrl = baseUrl + '/ActionPlan/' + actionPlanId + '/ActionPlanCriteria/' + actionPlanCriteriaId + '/FollowUp';

        return $http
                .get(reqUrl)
                .then(function (response) { return response.data; });
    };

    // Retrieve Action Plan Criterias (Deliverables) by Action Plan
    service.getActionPlanCriteriasByActionPlan = function (actionPlanId) {
        return $http
                .get(baseUrl + '/ActionPlan/' + actionPlanId + '/ActionPlanCriterias')
                .then(function (response) { return response.data; });
    };

    // Actions on action plan criterias (Deliverables)

    service.createActionPlanCriteria = function (actionPlanId, actionPlanCriteria) {
        return $http
                .post(baseUrl + '/ActionPlan/' + actionPlanId + '/ActionPlanCriteria',
                      actionPlanCriteria)
                .then(function (response) { return response.data; });
    };

    service.updateActionPlanCriteria = function (actionPlanCriteria) {
        return $http
                .put(baseUrl + '/ActionPlanCriteria/' + actionPlanCriteria.ActionPlanCriteriaID,
                     actionPlanCriteria)
                .then(function (response) { return response.data; });
    };

    service.deleteActiveAssessment = function (actionPlanCriteriaId) {
        var reqUrl = baseUrl +
                     '/ActionPlanCriteria/' + actionPlanCriteriaId +
                     '/Assesment/Active/Remove';

        return $http
                .post(reqUrl)
                .then(function (response) { return response.data; });
    };

    service.deleteActionPlanCriteria = function (actionPlanCriteria) {
        return $http
                .delete(baseUrl + '/ActionPlanCriteria/' + actionPlanCriteria.ActionPlanCriteriaID)
                .then(function (response) { return response.data; });
    };
    return service;
}]);
